import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { storeListQueries } from '@/services/mainPage/storeList/storeList.queries';
import { useParams, useSearch } from '@tanstack/react-router';

export const useMainPageStoreList = () => {
  const search = useSearch({ from: '/(app)/recommendation-management/main-page/$store-list/' });
  const { page, fetch, q } = search;
  const { ['store-list']: groupId } = useParams({
    from: '/(app)/recommendation-management/main-page/$store-list/',
  });
  const { data, isFetched, isLoading } = useQuery({
    ...storeListQueries.list({
      row: page,
      fetch: fetch,
      search: q,
      groupId,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
    enabled: !!fetch,
  });

  return {
    mainPageStore: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
